export default __webpack_public_path__ + "static/Messaging CTA Callout Graphics 1 – 300x600px-b14c64f1613485290ae35b0aef9b86a4.png";